/**
 * Redirige vers la page « navigateur obsolète » les navigateurs sous les versions minimales
 * supportées.
 *
 * ES5 uniquement, script classique : il doit s'exécuter sur les navigateurs trop anciens pour parser
 * le bundle applicatif, et s'y limite à détecter puis rediriger.
 *
 * Politique « fail-open » : seuls les moteurs explicitement reconnus sont bloqués, un UA inconnu
 * passe. Un faux positif enferme l'utilisateur dehors, sans contournement prévu.
 */
/* eslint-disable no-var -- ES5 imposé : ce fichier ne doit faire aucune hypothèse sur le moteur. */
(function () {
  /*
   * Domaine de la page, déduit du domaine courant faute d'accès à la configuration : le premier label
   * devient `accounts`, sauf s'il vaut déjà `app`.
   *
   * Rien de déductible sans sous-domaine : on laisse alors passer, conformément au fail-open.
   */
  var labels = location.hostname.split('.');
  if (labels[0] !== 'app') {
    labels.shift();
  }
  var PAGE =
    labels.length > 1
      ? location.protocol + '//accounts.' + labels.join('.') + '/assets/outdated-browser/index.html'
      : null;

  /* Versions majeures minimales supportées, par moteur. Seul réglage à toucher quand le socle
     évolue. */
  var MIN = {
    chromium: 119, // Chrome, Chrome for Android, Edge
    firefox: 119, // Firefox, Firefox for Android
    webkit: 17, // Safari, Safari for iOS, et tout navigateur sur iOS/iPadOS
  };

  var ua = navigator.userAgent;

  function major(regex) {
    var match = regex.exec(ua);
    return match ? parseInt(match[1], 10) : 0;
  }

  /** Un moteur non reconnu renvoie 0 et n'est jamais considéré comme obsolète. */
  function below(version, minimum) {
    return version > 0 && version < minimum;
  }

  function isOutdated() {
    // iOS / iPadOS : tous les navigateurs utilisent le WebKit du système, la version affichée par
    // Chrome (CriOS), Firefox (FxiOS) ou Edge (EdgiOS) ne dit donc rien du moteur réellement utilisé.
    if (/iPhone|iPad|iPod/.test(ua)) {
      return below(major(/OS (\d+)[_\d]* like Mac OS X/), MIN.webkit);
    }

    // Webview Android d'une application tierce : le moteur n'est pas maîtrisé par l'utilisateur,
    // qui n'a aucun moyen de le mettre à jour. On laisse passer.
    if (/;\s*wv\)/.test(ua)) {
      return false;
    }

    // Dérivés Chromium au versionnage propre à l'éditeur (Opera 105 = Chromium 119, etc.) :
    // la correspondance est fragile à maintenir, on ne les reconnaît pas.
    if (/OPR\/|SamsungBrowser\//.test(ua)) {
      return false;
    }

    // Edge avant Chrome : son UA contient aussi `Chrome/`.
    if (/Edg(A)?\//.test(ua)) {
      return below(major(/Edg(?:A)?\/(\d+)/), MIN.chromium);
    }

    if (/Firefox\//.test(ua)) {
      return below(major(/Firefox\/(\d+)/), MIN.firefox);
    }

    if (/Chrom(e|ium)\//.test(ua)) {
      return below(major(/Chrom(?:e|ium)\/(\d+)/), MIN.chromium);
    }

    // Safari macOS : seul moteur restant à exposer `Safari/`, Chrome ayant déjà été traité.
    if (/Safari\//.test(ua)) {
      return below(major(/Version\/(\d+)/), MIN.webkit);
    }

    return false;
  }

  /* Seul point d'entrée offert à la page, qui charge aussi ce script : elle rejoue le test à chaque
     chargement pour renvoyer vers l'application l'utilisateur ayant mis son navigateur à jour. */
  window.MM_OUTDATED_CHECK = isOutdated;

  /* La page se signale par un drapeau, qui empêche la redirection de s'y rejouer et de la recharger
     en boucle. Cible indéductible : fail-open. */
  if (window.MM_OUTDATED_ON_PAGE || !PAGE) {
    return;
  }

  if (isOutdated()) {
    // `replace` et non `href` : pas d'entrée d'historique, donc pas de boucle au bouton retour.
    //
    // `mmr` porte l'URL de départ, seule information transmise : la page en déduit le retour comme la
    // déclinaison à afficher. Nom de la convention maison pour une URL de retour, ce qui permet de le
    // relayer tel quel à l'authentification.
    location.replace(PAGE + '?mmr=' + encodeURIComponent(location.href));
  }
})();
